import { AppUrl } from "../config";
import { styled } from "@mui/material/styles";
import AccountBalance from "@mui/icons-material/AccountBalance";
import { Button } from "@mui/material";
import * as React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeftIcon } from "@mui/x-date-pickers";

const PREFIX = "ReturnToLandingPageButton";

const classes = {
  landingPageButton: `${PREFIX}-landingPageButton`,
  backArrowIcon: `${PREFIX}-backArrowIcon`,
};

const StyledButton = styled(Button)(({ theme }) => ({
  [`&.${classes.landingPageButton}`]: {
    "width": 240,
    "&.MuiButton-root.MuiButton-containedSecondary": {
      marginRight: "2rem",
      marginBottom: "2rem",
    },
  },

  [`& .${classes.backArrowIcon}`]: {
    margin: 2,
  },
}));

interface Props {
  resetState: (app: string) => void;
  currentApp: string;
}

export default function ReturnToLandingPageButton({
  resetState,
  currentApp,
}: Props) {
  const navigate = useNavigate();
  return (
    <StyledButton
      onClick={() => {
        resetState(currentApp);
        navigate(AppUrl("HomePage"));
      }}
      id="return-to-landing-page-button"
      className={classes.landingPageButton}
      variant="contained"
      color="secondary"
      startIcon={
        <>
          <ArrowLeftIcon className={classes.backArrowIcon} fontSize={"large"} />
          <AccountBalance />
        </>
      }
      disableElevation
    >
      BankFind Suite Home
    </StyledButton>
  );
}
